export const DefaultLanguage = {langaugeLocale: '', edition: 'ALL'};

export const Languages = [
    {langaugeLocale: 'en-EN', edition: 'EN'},
    {langaugeLocale: 'dk-DK', edition: 'DK'},
    {langaugeLocale: 'no-NO', edition: 'NO'},
    {langaugeLocale: 'fi-FI', edition: 'FI'},
    {langaugeLocale: 'se-SE', edition: 'SE'},
    DefaultLanguage
]